import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "iconfont icon-zhedie-shouqi"
}
const _hoisted_2 = {
  key: 1,
  class: "iconfont icon-zhedie-shouqi"
}
const _hoisted_3 = {
  key: 2,
  class: "iconfont icon-zhedie-zhankai"
}
const _hoisted_4 = {
  key: 3,
  class: "iconfont icon-zhedie-zhankai"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-gerenziliao2",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-rizhi",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-jiekou",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-tuichu1",
  style: {"margin-right":"7px","margin-left":"3px"}
}, null, -1)

import { ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router';
import { mapState, useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'UserHeadTop',
  setup(__props) {

var isWindow = window.innerWidth > 768;
const activeIndex = ref('1')
const user_conf = ref(JSON.parse(localStorage.getItem("user_conf") || "{}"));
const handleSelect = (key: string, keyPath: string[]) => {
    console.log(key, keyPath)
}
const store = useStore();


var isCollapse1 = ref(store.getters.isCollapse);
if (localStorage.getItem("isCollapse") == "-1") {
    store.commit('setIsCollapse', -1);
    isCollapse1.value = -1;
} else if (localStorage.getItem("isCollapse") == "1") {
    store.commit('setIsCollapse', 1);
    isCollapse1.value = 1;
} else {
    store.commit('setIsCollapse', 0);
    isCollapse1.value = 0;
}
// 处理点击事件以切换折叠状态
const toggleCollapse = () => {
    if (isCollapse1.value == 1) {
        isCollapse1.value = 0;
    } else if (isCollapse1.value == 0) {
        if (isWindow) {
            isCollapse1.value = 1;
        } else {
            isCollapse1.value = -1;
        }
    } else {
        isCollapse1.value = 0;
    }
    store.commit('setIsCollapse', isCollapse1.value);
    localStorage.setItem('isCollapse', isCollapse1.value);
};
const router = useRouter();
const navigateTo = (path: string) => {
    store.dispatch('setIsCollapse', isCollapse1.value);
    router.push(path);

}
const outLogin = () => {
    ElMessageBox.confirm(
        '您确定要退出登录吗？',
        'Warning',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            localStorage.removeItem("token");
            localStorage.removeItem("user_conf");
            ElMessage.success("退出登录成功")
            setTimeout(() => {
                location.reload();
            }, 1000);
        })
        .catch(() => {
            console.log();
        })
}


return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    style: {"border":"none !important"},
    class: "el-menu-demo",
    mode: "horizontal",
    ellipsis: false,
    "background-color": "#000000",
    "text-color": "#fff",
    onSelect: handleSelect
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "nav-el-radio",
        style: {"height":"fit-content","font-weight":"bold","margin-top":"1rem","margin-left":"0.5rem","color":"white"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleCollapse()))
      }, [
        (_unref(isCollapse1) == 1 && _unref(isWindow))
          ? (_openBlock(), _createElementBlock("span", _hoisted_1))
          : (_unref(isCollapse1) == 0 && !_unref(isWindow))
            ? (_openBlock(), _createElementBlock("span", _hoisted_2))
            : (_unref(isCollapse1) == 0 && _unref(isWindow))
              ? (_openBlock(), _createElementBlock("span", _hoisted_3))
              : (_openBlock(), _createElementBlock("span", _hoisted_4))
      ]),
      _createVNode(_component_el_sub_menu, {
        style: {"right":"0","position":"absolute"},
        index: "1"
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(user_conf.value.user_email?(user_conf.value.username?user_conf.value.username:"未设置"):"未登录"), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, {
            index: "1-1",
            class: "ml-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateTo('/')))
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode("个人资料")
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, {
            index: "1-2",
            class: "ml-2",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateTo('/userLog')))
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode("用户日志")
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, {
            index: "1-3",
            class: "ml-2",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (navigateTo('/dockKey')))
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode("对接密钥")
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, {
            index: "1-4",
            class: "ml-2",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (outLogin()))
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createTextVNode("退出")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})